module.exports = __webpack_public_path__ + "img/logo.6af15c31.png";